<template>
  <div id="app">
    <component :is="layout">
      <router-view :key="$route.name + ($route.params.code || '')" />
    </component>
  </div>
</template>

<script>
const DEFAULT_LAYOUT = "default"; // todo: вынести в отдельный файл

export default {
  name: "app",
  computed: {
    layout() {
      return (this.$route.meta.layout || DEFAULT_LAYOUT) + "-layout";
    },
    seo() {
      return this.$store.state.seo;
    }
  },
  async created() {
    await this.$store.dispatch('getSeo');
  },
  watch: {
    $route: {
      async handler(to, from) {
        if (this.seo) {
          let currentSeo = this.seo[to.path];
          if (!currentSeo) {
            currentSeo = this.seo['default'];
          }

          document.title = currentSeo.title;

          const descriptionMeta = document.getElementsByTagName('meta')["description"];
          if (descriptionMeta) {
            descriptionMeta.content = currentSeo.description;
          } else {
            const meta = document.createElement('meta');
            meta.name = 'description';
            meta.content = currentSeo.description;
            document.getElementsByTagName('head')[0].appendChild(meta);
          }

          const keywordsMeta = document.getElementsByTagName('meta')["keywords"];
          if (keywordsMeta) {
            keywordsMeta.content = currentSeo.keywords;
          } else {
            const meta = document.createElement('meta');
            meta.name = 'keywords';
            meta.content = currentSeo.keywords;
            document.getElementsByTagName('head')[0].appendChild(meta);
          }

          const h1 = document.getElementsByClassName('seo_h1')[0];
          if (h1) {
            h1.textContent = currentSeo.h1;
          } else {
            const h1Tag = document.createElement('h1');
            h1Tag.classList.add('seo_h1');
            h1Tag.textContent = currentSeo.h1;
            document.getElementsByTagName('body')[0].appendChild(h1Tag);
          }

          const h2 = document.getElementsByClassName('seo_h2')[0];
          if (h2) {
            h2.textContent = currentSeo.h2;
          } else {
            const h2Tag = document.createElement('h2');
            h2Tag.classList.add('seo_h2');
            h2Tag.textContent = currentSeo.h2;
            document.getElementsByTagName('body')[0].appendChild(h2Tag);
          }
        }

        const html = document.getElementsByTagName('html')[0];

        if (from !== undefined && from.name) {
          let fromClass = from.name.toLowerCase();
          if (fromClass === 'promo' || fromClass === 'promo-invest') fromClass = '___redesign';
          if (fromClass === 'login') fromClass = '___redesign';
          html.classList.remove(fromClass);
        }
        if (to.name) {
          let toClass = to.name.toLowerCase();
          if (toClass === 'promo' || toClass === 'promo-invest') toClass = '___redesign';
          if (toClass === 'login') toClass = '___redesign';
          html.classList.add(toClass);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
@import './assets/css/redesign/fonts';
@import './assets/css/fonts';

* {
  box-sizing: border-box;
}

html.___redesign {
  @import './assets/css/redesign.scss';
}

html:not(.___redesign) {
  @import './assets/css/all';
}

html {
  font-size: 10px;
}
</style>

<style>
.seo_h1 {
  display: none !important;
}

.seo_h2 {
  display: none !important;
}
</style>